import { API, get } from "../../config";

export const getAssetDetail = async (assetId) => {
  try {
    const { data } = await get(`${API.ASSET_DETAILS}/` + assetId);
    return data.data;
  } catch (e) {
    return null;
  }
};

export const getAssetPopupDetail = async (assetId) => {
  try {
    const { data } = await get(`${API.ASSET_DETAILS}/${assetId}`);
    return data.data;
  } catch (error) {
    return null;
  }
};
